import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DropdownSelector from '../../common/DropdownSelector';
import {
    getOwnersProperties,
    getOwnerSelectedPropertyId,
} from '../../stores/dashboard/selectors';
import { setOwnerSelectedPropertyId } from '../../stores/dashboard/actions';
import { Typography, withStyles } from '@material-ui/core';
import styles from './styles';

const PropertySelector = (props) => {
    const dispatch = useDispatch();
    const properties = useSelector(getOwnersProperties);
    const selectedPropertyId = useSelector(getOwnerSelectedPropertyId);

    const options = properties.map((property) => ({
        key: property.propertyId,
        value: property.propertyName || property.propertyId,
    }));

    const handleDropdownChange = (event, propertyId) => {
        if (propertyId !== selectedPropertyId) {
            dispatch(setOwnerSelectedPropertyId(propertyId));
        }
    };

    return (
        <>
            <Typography className={props.classes.titleStyle}>
                Location Report
            </Typography>
            <DropdownSelector
                options={options}
                value={selectedPropertyId}
                onChange={handleDropdownChange}
                includeAll={true}
                allLabel="All Properties"
                maxWidth="400px"
            />
        </>
    );
};

export default withStyles(styles)(PropertySelector);
